import { configureStore } from "@reduxjs/toolkit";
import detailsToSendSlice from "../slice/detailsToSendSlice";
import userDetailsSlice from "../slice/userDetailsSlice"
import settlementDetailsSlice from "../slice/SettlementeDetailsSlice"
import bbpsDetailsToSendSlice from "../slice/bbpsDetailsToSendSlice"
import activeFeaturesSlice from "../slice/activeFeaturesSlice"
import locationSlice from "../slice/locationSlice"

const store = configureStore({
    reducer:{
      details : detailsToSendSlice,
      user : userDetailsSlice,
      settlementDetails : settlementDetailsSlice,
      transaction : bbpsDetailsToSendSlice,
      activeFeatures : activeFeaturesSlice,
      locationPermission : locationSlice
    }
})
export default store;